import { Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { TikTokIcon } from "@/components/icons/TikTokIcon";

const SUPPLIER_FOOTER_LINKS = {
  weddingly: [
    { label: "Paket och priser", href: "/anslut-ditt-foretag/priser" },
    { label: "Registrera ditt företag", href: "/anslut-ditt-foretag" },
    { label: "Företagsartiklar", href: "/anslut-ditt-foretag/foretagsartiklar" },
    { label: "Annonsera hos oss", href: "/annonsera-hos-oss" },
  ],
  branscher: [
    { label: "Bröllopslokaler", href: "/anslut-ditt-foretag/brollopslokaler" },
    { label: "Fotografer", href: "/anslut-ditt-foretag/fotografer" },
    { label: "Videografer", href: "/anslut-ditt-foretag/videografer" },
    { label: "Brudklänningar", href: "/anslut-ditt-foretag/brudklanningar" },
    { label: "Bröllopskostym", href: "/anslut-ditt-foretag/brollopskostym" },
    { label: "Makeupartist", href: "/anslut-ditt-foretag/brudmakeup" },
    { label: "Frisör", href: "/anslut-ditt-foretag/brudfrisyrer" },
    { label: "Vigselringar", href: "/anslut-ditt-foretag/vigselringar" },
    { label: "Catering", href: "/anslut-ditt-foretag/catering" },
    { label: "Bröllopstårtor", href: "/anslut-ditt-foretag/brollopstartor" },
    { label: "Florist", href: "/anslut-ditt-foretag/brudbukett" },
    { label: "Musik", href: "/anslut-ditt-foretag/musik" },
    { label: "Underhållning", href: "/anslut-ditt-foretag/underhallning" },
    { label: "Bröllopsplanerare", href: "/anslut-ditt-foretag/brollopsplanerare" },
    { label: "Bröllopskort", href: "/anslut-ditt-foretag/brollopskort" },
    { label: "Uthyrning", href: "/anslut-ditt-foretag/uthyrning" },
    { label: "Bröllopstransport", href: "/anslut-ditt-foretag/brollopsbilar" },
  ],
  mer: [
    { label: "Leverantörsvillkor", href: "/leverantor-villkor" },
    { label: "Integritetspolicy", href: "/privacy-policy" },
    { label: "Cookieinställningar", href: "/cookie-settings" },
    { label: "Användarvillkor", href: "/terms-and-conditions" },
  ],
};

const socialIcons = [
  {
    icon: Instagram,
    link: "https://www.instagram.com/weddinglysverige/",
    name: "Instagram",
  },
  {
    icon: TikTokIcon,
    link: "https://www.tiktok.com/@weddinglysverige?_r=1&_t=ZN-94onChqPKTe",
    name: "TikTok",
  },
];

export const SupplierFooter = () => {
  return (
    <footer className="w-full bg-[#f8f9fb] border-t border-gray-200">
      <div className="max-w-[1170px] mx-auto px-[50px] pt-16 pb-8 max-sm:px-5">
        <div className="grid grid-cols-4 gap-8 max-lg:grid-cols-2 max-sm:grid-cols-1 mb-12">
          {/* Brand blurb */}
          <div>
            <img
              src="/lovable-uploads/weddingly-footer-logo.webp"
              className="w-[190px] h-[55px] mb-6"
              alt="Weddingly logotyp"
              width="190"
              height="55"
              loading="lazy"
            />
            <p className="text-[#333] text-base font-normal leading-[26px] max-w-[300px]">
              Nå tusentals brudpar och väx din verksamhet med Weddingly – Sveriges
              moderna bröllopsplattform.
            </p>
          </div>

          {/* Weddingly links */}
          <div>
            <h3 className="text-[#212121] text-lg font-bold leading-[18px] capitalize mb-6">
              Weddingly
            </h3>
            <nav>
              <ul className="space-y-3">
                {SUPPLIER_FOOTER_LINKS.weddingly.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-[#333] text-base font-normal hover:text-gray-500 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
                <li>
                  <a
                    href="mailto:info@weddingly.se"
                    className="text-[#333] text-base font-normal hover:text-gray-500 transition-colors"
                  >
                    Kontakta oss
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Branscher */}
          <div>
            <h3 className="text-[#212121] text-lg font-bold leading-[18px] capitalize mb-6">
              Branscher
            </h3>
            <nav>
              <ul className="space-y-3">
                {SUPPLIER_FOOTER_LINKS.branscher.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-[#333] text-base font-normal hover:text-gray-500 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Mer */}
          <div>
            <h3 className="text-[#212121] text-lg font-bold leading-[18px] capitalize mb-6">
              Mer
            </h3>
            <nav>
              <ul className="space-y-3">
                {SUPPLIER_FOOTER_LINKS.mer.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-[#333] text-base font-normal hover:text-gray-500 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-200 pt-6">
          <div className="flex justify-between items-center max-sm:flex-col max-sm:gap-4">
            <div className="flex items-center gap-4">
              {socialIcons.map((social, index) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={index}
                    href={social.link}
                    aria-label={`Besök oss på ${social.name}`}
                    className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200/60 hover:bg-gray-300/60 transition-colors"
                  >
                    <IconComponent className="w-4 h-4 text-gray-600" />
                  </a>
                );
              })}
            </div>
            <p className="text-[#666] text-sm font-normal">
              Copyright &copy; weddingly.se {new Date().getFullYear()} | All
              rights reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
